import { createFileRoute, Outlet } from '@tanstack/react-router';

import { meQueryOptions } from '@/features/me/api';
import { AppShell } from '@/layout/app-shell';
import { sessionStore } from '@/shared/auth/session-store';

/**
 * 화면 틀 — 로그인 없이도 볼 수 있다 (충전 화면은 공개, 로그인이 필요한 화면은 _auth 아래).
 * 로그인돼 있으면 헤더의 잔액·프로필을 기다리지 않고 미리 요청한다.
 */
export const Route = createFileRoute('/_app')({
  loader: ({ context }) => {
    if (sessionStore.get()) {
      void context.queryClient.query(meQueryOptions()).catch(() => undefined);
    }
  },
  component: AppLayout,
});

function AppLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
